import validate from "/var/www/go-vue/client/node_modules/.pnpm/nuxt@3.19.2_@vue+compiler-sfc@3.5.21_eslint@8.48.0_rollup@4.52.2_sass@1.93.1_typescript@5.9.2_vite@6.3.6/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/go-vue/client/node_modules/.pnpm/nuxt@3.19.2_@vue+compiler-sfc@3.5.21_eslint@8.48.0_rollup@4.52.2_sass@1.93.1_typescript@5.9.2_vite@6.3.6/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}